import * as React from "react";
import { useEffect } from "react";
import styled from "styled-components";
import EntityShareDomain from "domainActions/permissions/EntityShareDomain";
import { useSetEntityShareState } from "hooks/useEntityShareState";
import GranteesSelector from "components/permissions/Grantee/GranteesSelector";
import GranteesList from "components/permissions/Grantee/GranteesList";
import usePluggableEntityCollectionGranteeList from "hooks/usePluggableEntityCollectionGranteeList";
import ShareableEntityURL from "./ShareableEntityURL";
import EntityShareValidationsDependencies from "./EntityShareValidationsDependencies";
const Section = styled.div`
  margin-bottom: 25px;

  &:last-child {
    margin-bottom: 0;
  }
`;
const GranteesSelectorHeadline = styled.h5`
  margin-bottom: 10px;
`;
const _filterAvailableGrantees = (availableGrantees, selectedGranteeCapabilities) => {
  const availableGranteeCapabilitiesUserIds = selectedGranteeCapabilities.entrySeq().map(([granteeGRN]) => granteeGRN);
  return availableGrantees.filter((grantee) => !availableGranteeCapabilitiesUserIds.includes(grantee.id));
};
const EntityShareSettings = ({
  entityShareState: {
    activeShares,
    availableGrantees,
    availableCapabilities,
    missingDependencies,
    selectedGranteeCapabilities,
    selectedGrantees,
    validationResults
  },
  description,
  entityGRN,
  entityType,
  entityTitle,
  setDisableSubmit,
  granteesSelectFormRef,
  showShareableEntityURL = true,
  entityTypeTitle = null
}) => {
  const filteredGrantees = _filterAvailableGrantees(availableGrantees, selectedGranteeCapabilities);
  const CollectionGranteeList = usePluggableEntityCollectionGranteeList();
  const setEntityShareState = useSetEntityShareState();
  useEffect(() => {
    setDisableSubmit(validationResults == null ? void 0 : validationResults.failed);
  }, [validationResults, setDisableSubmit]);
  const _handleSelection = ({ granteeId, capabilityId }) => {
    const newSelectedCapabilities = selectedGranteeCapabilities.merge({ [granteeId]: capabilityId });
    setDisableSubmit(true);
    const payload = {
      selected_grantee_capabilities: newSelectedCapabilities
    };
    return EntityShareDomain.prepare(entityType, entityTitle, entityGRN, payload).then((state) => {
      setEntityShareState(entityGRN, state);
      return state;
    });
  };
  const _handleDeletion = (granteeId) => {
    const newSelectedGranteeCapabilities = selectedGranteeCapabilities.remove(granteeId);
    setDisableSubmit(true);
    const payload = {
      selected_grantee_capabilities: newSelectedGranteeCapabilities
    };
    return EntityShareDomain.prepare(entityType, entityTitle, entityGRN, payload).then((state) => {
      setEntityShareState(entityGRN, state);
      return state;
    });
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Section, null, /* @__PURE__ */ React.createElement(GranteesSelectorHeadline, null, "Add Collaborator"), /* @__PURE__ */ React.createElement("p", null, description), /* @__PURE__ */ React.createElement(
    GranteesSelector,
    {
      availableGrantees: filteredGrantees,
      availableCapabilities,
      onSubmit: _handleSelection,
      formRef: granteesSelectFormRef
    }
  )), /* @__PURE__ */ React.createElement(
    GranteesList,
    {
      activeShares,
      availableCapabilities,
      entityType,
      entityTypeTitle,
      onDelete: _handleDeletion,
      onCapabilityChange: _handleSelection,
      selectedGrantees,
      title: "Direct Collaborators"
    }
  ), CollectionGranteeList && /* @__PURE__ */ React.createElement(
    CollectionGranteeList,
    {
      title: "Shared via Collections",
      entityType,
      entityTypeTitle,
      entityGRN
    }
  ), /* @__PURE__ */ React.createElement(
    EntityShareValidationsDependencies,
    {
      missingDependencies,
      validationResults,
      availableGrantees
    }
  ), showShareableEntityURL && /* @__PURE__ */ React.createElement(Section, null, /* @__PURE__ */ React.createElement(ShareableEntityURL, { entityGRN })));
};
export default EntityShareSettings;
